import React, { useState } from 'react';
import { Box, Scan, CheckCircle2 } from 'lucide-react';

export const InventoryModule: React.FC = () => {
  const [deviceFilter, setDeviceFilter] = useState('ALL');
  const [barcodeScanned, setBarcodeScanned] = useState('');
  const [scanMsg, setScanMsg] = useState('');

  const handleSimulateScan = () => {
    const mockBarcode = `DEV-2026-${Math.floor(1000 + Math.random() * 9000)}`;
    setBarcodeScanned(mockBarcode);
    setScanMsg(`Scanned Barcode "${mockBarcode}" — Hardware status: Calibrated & Available`);
    setTimeout(() => setScanMsg(''), 4000);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-amber-100 text-amber-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Assistive Technology Hardware Inventory
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Assistive Device Inventory & Lender Engine</h2>
          <p className="text-xs text-slate-500">Hardware device check-in/out, barcode scanner, and calibration schedule</p>
        </div>

        <button 
          onClick={handleSimulateScan}
          className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-bold text-xs rounded-xl shadow transition flex items-center gap-1.5"
        >
          <Scan className="w-4 h-4" />
          <span>Simulate Barcode Scan</span>
        </button>
      </div>

      {scanMsg && (
        <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-xl text-xs font-bold flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          {scanMsg}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <label className="block text-xs font-bold text-slate-700">Filter Hardware Inventory</label>
          <div className="flex gap-2">
            {['ALL', 'AVAILABLE', 'CHECKED_OUT', 'MAINTENANCE'].map(st => (
              <button
                key={st}
                onClick={() => setDeviceFilter(st)}
                className={`px-3 py-1.5 rounded-lg text-xs font-bold transition ${
                  deviceFilter === st ? 'bg-amber-600 text-white shadow' : 'bg-white text-slate-700 border'
                }`}
              >
                {st}
              </button>
            ))}
          </div>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-2 text-xs">
          <div className="font-bold text-slate-900">Latest Scanner Input</div>
          <div className="font-mono bg-white p-2.5 rounded-xl border font-bold text-slate-800">
            {barcodeScanned || 'DEV-2026-9021 (Tobii Dynavox I-16 Eye Tracker)'}
          </div>
        </div>
      </div>
    </div>
  );
};
